import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { billingErrorToast } from '@components/BillingError/toast';
import {
  UpdatePaymentMethodToDefaultParams,
  updatePaymentMethodToDefault,
} from '@utils/backend-api/stripe';
import { BillingErrorPayload, normalizeBillingError } from '@utils/billingErrors';

export default function useSetPaymentMethodToDefault() {
  const { mutate, mutateAsync, isLoading } = useMutation(
    (values: UpdatePaymentMethodToDefaultParams) => updatePaymentMethodToDefault(values),
    {
      onSuccess: (data) => {
        // Set when a past-due charge was attempted; the result is flashed on the reloaded page.
        if (data?.redirect_to) {
          window.location.href = data.redirect_to;
          return;
        }
        toast.success('Payment method has been updated');
      },
      onError: (error: Partial<BillingErrorPayload> & { message?: string }) => {
        billingErrorToast(
          normalizeBillingError(error, 'Payment method was not saved. Please try again.')
        );
      },
    }
  );

  return {
    mutate,
    mutateAsync,
    isLoading,
  };
}
